import {ReactElement} from "react";
import {Routes} from "react-router-dom";
import {Route} from "react-router";
import {MenuManagement} from "./menumanagement/MenuManagement";
import {CreateMenu} from "./CreateMenu";
import {MenuEditorPage} from "./MenuEditorPage";

export interface MenuSectionProps {

}

export function MenuSection(props: MenuSectionProps): ReactElement {
    return (
        <Routes>
            <Route index element={<MenuManagement />} />
            <Route path="create/:menuType" element={<CreateMenu />} />
            <Route path="edit/:menuId" element={<MenuEditorPage />} />
        </Routes>
    );
}